import { useQueryErrorHandler } from '@/shared/hooks/useQueryErrorHandler.ts';
import { useMutation } from '@tanstack/react-query';
import { useCreatePositionClientV2 } from './positionV2.ts';

export function useSubmitPositionV2() {
    const { handleMutationErrors } = useQueryErrorHandler();
    const { createPositionV2 } = useCreatePositionClientV2();

    return useMutation({
        ...handleMutationErrors,
        mutationFn: createPositionV2,
    });
}
